// MAKØ — Reveal on scroll (progressive enhancement, no dependencies)
// Content is fully visible without JS. This only adds a subtle entrance.
// Respects prefers-reduced-motion.
(() => {
  if (window.__makoRevealInit) return;
  window.__makoRevealInit = true;

  const SELECTOR = '[data-mako-reveal]';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Reveal with a subtle staggered delay so grid rows cascade in.
  const reveal = (el) => {
    const parent = el.parentElement;
    if (parent) {
      const sibs = parent.querySelectorAll(':scope > [data-mako-reveal]');
      if (sibs.length > 1) {
        let i = 0;
        for (; i < sibs.length; i++) {
          if (sibs[i] === el) break;
        }
        el.style.transitionDelay = (i % 4) * 60 + 'ms';
      }
    }
    el.setAttribute('data-mako-in', '');
  };

  const init = () => {
    const nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    // Mark that JS is active so CSS can apply the hidden->shown transition.
    document.documentElement.setAttribute('data-mako-reveal-ready', '');

    if (reduce.matches || !('IntersectionObserver' in window)) {
      nodes.forEach(reveal);
      return;
    }

    const io = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            reveal(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.12 }
    );

    nodes.forEach((el) => io.observe(el));
  };

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init, { once: true });
})();
